var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 745.65 200.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 100.11,
    cy: 100.11,
    r: 92.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.11,
    y1: 32.82,
    x2: 100.11,
    y2: 107.39,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.99,
    y1: 100.11,
    x2: 92.73,
    y2: 100.11,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,78.56a84.59,84.59,0,0,1,14.44,1.31,58.3,58.3,0,0,1,12.59,3.45l-2.31,10.9a78.94,78.94,0,0,0-11.21-3,62.26,62.26,0,0,0-11.82-1.15q-19.19,0-29.93,10.75t-10.75,30.7q0,20,10.75,30.71T345.55,173a62.26,62.26,0,0,0,11.82-1.15,77.62,77.62,0,0,0,11.21-3l2.31,10.9a58.3,58.3,0,0,1-12.59,3.45,84.59,84.59,0,0,1-14.44,1.31,59.76,59.76,0,0,1-22.49-4,47.06,47.06,0,0,1-16.66-11.06,48.33,48.33,0,0,1-10.36-16.73,64,64,0,0,1,0-42.38,48.52,48.52,0,0,1,10.36-16.73,47,47,0,0,1,16.66-11A59.76,59.76,0,0,1,343.86,78.56Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,182.66V74.27h13.81v44.06a31.07,31.07,0,0,1,10-8.14,28.56,28.56,0,0,1,12.9-2.76,22.82,22.82,0,0,1,11.82,2.91,24.59,24.59,0,0,1,8.14,7.91,35.08,35.08,0,0,1,4.68,11.59,64.78,64.78,0,0,1,1.46,14v38.85H438.28V144.27a54.17,54.17,0,0,0-.92-10.36,25.29,25.29,0,0,0-2.92-8.06,14.9,14.9,0,0,0-5.22-5.3,15.14,15.14,0,0,0-7.83-1.91,18.61,18.61,0,0,0-10.82,3.22,33.72,33.72,0,0,0-7.45,6.75v54Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.76,107.43a30.87,30.87,0,0,1,12.36,2.3,25.12,25.12,0,0,1,14.28,15.74,38.09,38.09,0,0,1,1.76,11.74,51.24,51.24,0,0,1-1.53,12.44H483.11a34.74,34.74,0,0,0,1.53,9.67,20.22,20.22,0,0,0,4.23,7.45,18.27,18.27,0,0,0,7.37,4.83,31.35,31.35,0,0,0,11,1.69,49.84,49.84,0,0,0,11.29-1.23,62.33,62.33,0,0,0,9.75-3.07l1.84,10.29a50.46,50.46,0,0,1-11.44,3.61,69.11,69.11,0,0,1-13.43,1.3,39.87,39.87,0,0,1-16.05-3,31.32,31.32,0,0,1-11.28-8.14A34.17,34.17,0,0,1,471.21,161a50.5,50.5,0,0,1,.08-29.94A37.2,37.2,0,0,1,478,118.71a30.81,30.81,0,0,1,10.67-8.29A32.52,32.52,0,0,1,502.76,107.43Zm-.46,10.28a17.36,17.36,0,0,0-7.83,1.69,18.25,18.25,0,0,0-5.83,4.61,21.58,21.58,0,0,0-3.84,6.83,31.13,31.13,0,0,0-1.69,8.21h34.7a31.57,31.57,0,0,0-.16-8.21A17.91,17.91,0,0,0,515.2,124a13.07,13.07,0,0,0-5.07-4.61A16.77,16.77,0,0,0,502.3,117.71Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.52,107.27A58.53,58.53,0,0,1,591,108.36a39.1,39.1,0,0,1,9.21,3l-2,10.69a46,46,0,0,0-17.5-3.53q-12.43,0-18.35,7.58t-5.91,19.67q0,12.11,5.91,19.67T580.75,173a44.52,44.52,0,0,0,9-.92,44,44,0,0,0,8.52-2.61l2,10.69a38,38,0,0,1-9.67,3,60.06,60.06,0,0,1-11.06,1.09,39.35,39.35,0,0,1-16.12-3.08,32.48,32.48,0,0,1-11.51-8.38A35.39,35.39,0,0,1,545,160.42,48.06,48.06,0,0,1,545,131a35.34,35.34,0,0,1,6.91-12.3,32.5,32.5,0,0,1,11.51-8.39A39.35,39.35,0,0,1,579.52,107.27Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.14,182.66V74.27H631v69.54L660.43,109h16L645.23,145.2,679,182.66H662.27L631,146.12v36.54Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708,182.66H693.9V80.41H708Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.59,182.66V109h13.2v10.75a30,30,0,0,1,10-9.06,27.46,27.46,0,0,1,13.51-3.22,22.82,22.82,0,0,1,11.82,2.91,24.69,24.69,0,0,1,8.14,7.91,35.3,35.3,0,0,1,4.68,11.59,64.78,64.78,0,0,1,1.46,14v38.85H781.56V144.27a54.17,54.17,0,0,0-.92-10.36,25.53,25.53,0,0,0-2.92-8.06,14.9,14.9,0,0,0-5.22-5.3,15.14,15.14,0,0,0-7.83-1.91,18.61,18.61,0,0,0-10.82,3.22,33.5,33.5,0,0,0-7.45,6.75v54Z",
    transform: "translate(-49.72 -29.28)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinWhite);
export default __webpack_public_path__ + "static/media/Checkin-white.422f2e1f5082ed462d0d33aab93be98e.svg";
export { ForwardRef as ReactComponent };